import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetUsers({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("USER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/admin", option);
    commit("USER_SUCCESS", _response);
  } catch (error) {
    commit("USER_ERROR", { result: error.message });
  }
}

export async function CreateUser({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("CREATE_USER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/admin", form);
    commit("CREATE_USER_SUCCESS", _response.data);
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_USER_ERROR", { result: error.message });
  }
}

export async function GetUser({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_USER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/v1/admin", id);
    commit("GET_USER_SUCCESS", _response);
  } catch (error) {
    commit("GET_USER_ERROR", { result: error.message });
  }
}

export async function UpdateUser({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_USER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/admin/" + form.id, form);
    commit("EDIT_USER_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_USER_ERROR", { result: error.message });
  }
}

export async function UpdateStatusUser({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_USER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/admin/" + form.id, form);
    commit("EDIT_USER_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
  } catch (error) {
    commit("EDIT_USER_ERROR", { result: error.message });
  }
}

export async function DeleteUser({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("DELETE_USER_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/v1/admin/" + id);
    commit("DELETE_USER_SUCCESS", id);
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_USER_ERROR", { result: error.message });
  }
}
